import request from "@src/util/request";
import { helper } from "@src/controls/controlHelper";

export type DashboardSalesChannel = "ONLINE" | "INVITATION";

export interface DashboardRequestBody {
  from?: number;
  to?: number;
  eventId?: number;
  salesChannel?: DashboardSalesChannel;
}

export interface DashboardTicketEventItem {
  eventId: number;
  name: string;
  checkedIn: number;
  sold: number;
}

export interface DashboardTicketData {
  revenue: number;
  successOrders: number;
  checkins: number;
  sold: {
    online: number;
    invitation: number;
  };
  events: DashboardTicketEventItem[];
}

export interface DashboardProductData {
  revenue: number;
  successOrders: number;
}

export interface DashboardRevenueOverTimeItem {
  period: string;
  revenue: number;
  orders: number;
}

export interface DashboardOrdersOverTimeItem {
  period: string;
  total: number;
  online: number;
  invitation: number;
}

export interface DashboardTicketsByTypeItem {
  ticketId: number;
  name: string;
  sold: number;
  revenue: number;
}

export interface DashboardCheckinOverTimeItem {
  period: string;
  checkins: number;
}

export interface DashboardTopEventItem {
  eventId: number;
  name: string;
  sold: number;
  revenue: number;
}

export interface DashboardResponseData {
  code: number;
  data: {
    summary: {
      ticket: DashboardTicketData;
      product: DashboardProductData;
    };
    charts: {
      revenueOverTime: DashboardRevenueOverTimeItem[];
      ordersOverTime: DashboardOrdersOverTimeItem[];
      ticketsByType: DashboardTicketsByTypeItem[];
      checkinOverTime: DashboardCheckinOverTimeItem[];
      topEvents: DashboardTopEventItem[];
    };
  };
}

export async function fetchAdminDashboard(body: DashboardRequestBody = {}) {
  return request<DashboardResponseData>({
    url: `/admin/dashboard`,
    options: {
      method: "post",
      data: body,
    },
  });
}

export interface FindEventItem {
  id: number;
  nameEvent: string;
}

export async function findEventsFromPage121(
  params: { search?: string; skip?: number; limit?: number } = {}
) {
  const pageInfo = await helper.getPage(121 as number);
  const rs: any = await helper.callPageApi(pageInfo, "find_event", {
    queryInput: params.search
      ? JSON.stringify({ nameEvent: { contains: params.search } })
      : undefined,
    select: "id,nameEvent",
    limit: typeof params.limit === "number" ? params.limit : 20,
    skip: typeof params.skip === "number" ? params.skip : 0,
    sort: [{ id: "desc" }],
  });
  return {
    items: ((rs?.data?.data || []) as FindEventItem[]) || [],
    total: rs?.data?.total || rs?.data?.count || 0,
  };
}
